import React from 'react';
import { Link } from 'react-router';

const GiveBackCallout = () => (
  <div className="callout primary">
    <p>
      <Link to="/give-back/" target="_blank">Give Back</Link> is crowdspring&#39;s way of helping
      worthy non-profit and charitable causes around the world when those organizations need design
      help but cannot afford it. For these special projects, no monetary awards will be given and
      crowdspring will waive all fees. Crowdspring will help each organization post their project.
      Together, we will collaborate to help those who are less fortunate.
    </p>
    <p>
      Give Back projects will work just like standard projects, including contracts, wrap-up,
      notifications, etc.
    </p>
    <p>
      We will find ways to recognize winning designers in Give Back projects.
    </p>
    <p>
      We&#39;ll also ask the winning designers in Give Back projects to propose other worthy
      non-profits and charities that can benefit from this program. We hope that in this small way,
      crowdspring and our community can help non-profits and charities around the world.
    </p>
  </div>
)

export default GiveBackCallout;



// WEBPACK FOOTER //
// ./project/components/give_back_callout.jsx